enum NumericCompletionCondition {
    LessThanOrEqual = 1,
    GreaterThanOrEqual = 2,
}

export default NumericCompletionCondition;
